import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Shell } from "./components/layout/Shell";
import { HomeView } from "../learn/views/HomeView";
import { CourseView } from "../learn/views/CourseView";
import { LessonRoute } from "../learn/views/LessonRoute";

export function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Shell />}>
          <Route index element={<HomeView />} />
          <Route path="classic" element={<CourseView course="classic" />} />
          <Route path="csp" element={<CourseView course="apcsp" />} />
          <Route
            path=":unit/:lesson"
            element={<LessonRoute course="classic" />}
          />
          <Route
            path="csp/:unit/:lesson"
            element={<LessonRoute course="apcsp" />}
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
